import React, { useCallback } from 'react'
import { CreditCardData } from '~/types'
import { RemoveCardApiResponse } from '~/types/api'
import styled from 'styled-components'
import Button from '~/components/atoms/Button'
import axios from '~/lib/axios'
import { useDispatch } from '~/lib/hooks/redux'
import { useBusy } from '~/lib/hooks/busy'

interface Props {
  creditCard: CreditCardData
  busy: boolean
  onClick(): void
  onRemove(): void
}

export default function CreditCardArea({ creditCard, busy, onClick, onRemove }: Props) {
  const dispatch = useDispatch()
  const [_, startBusy, endBusy] = useBusy()

  const handleRemoveCard = useCallback(async () => {
    if (confirm('本当に削除して良いですか？')) {
      startBusy()
      await axios<RemoveCardApiResponse>(
        {
          method: 'delete',
          url: '/users/cards'
        },
        { dispatch }
      )
      endBusy()
      onRemove()
    }
  }, [onRemove])

  if (creditCard === undefined) {
    return <Skeleton />
  }

  if (creditCard) {
    return (
      <SettingContainer>
        <SettingHead>
          {creditCard.brand}&nbsp;••••{creditCard.last4}
          <RemoveCard onClick={handleRemoveCard}>カード情報を削除</RemoveCard>
        </SettingHead>
        <Button label='変更する' color='secondary' onClick={onClick} size='s' disabled={busy} />
      </SettingContainer>
    )
  }

  return (
    <SettingContainer>
      <SettingHead>支払い方法</SettingHead>
      <Button label='設定する' color='primary' onClick={onClick} size='s' disabled={busy} />
    </SettingContainer>
  )
}

const Skeleton = styled.div`
  height: 40px;
`
const SettingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const SettingHead = styled.div`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface2};
  text-align: left;
`
const RemoveCard = styled.div`
  ${({ theme }) => theme.fonts.Bold14};
  color: ${({ theme }) => theme.colors.Primary};
  cursor: pointer;
`
